module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('textarea', {
    ref: "textarea",
    attrs: {
      "readonly": _vm.state !== 'editor'
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.update($event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6957e78c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/document-parts/pricing-table-textarea.vue
// module id = 532
// module chunks = 0